/*
 * @Description:
 * @Author: kadenwang@tencent.com
 * @Date: 2020-05-19 15:46:03
 * @LastEditors: kadenwang@tencent.com
 * @LastEditTime: 2020-09-24 20:32:00
 */

import { getCookie } from '@tencent/halo-utils';

export function sleep(time) { // 休眠一段时间
  return new Promise<void>(((resolve) => {
    setTimeout(() => {
      resolve();
    }, time);
  }));
}

export function versionCompare(v1, v2, options?: any) {
  const lexicographical = options && options.lexicographical;
  const zeroExtend = options && options.zeroExtend;
  let v1parts = v1.split('.');
  let v2parts = v2.split('.');

  function isValidPart(x) {
    return (lexicographical ? /^\d+[A-Za-z]*$/ : /^\d+$/).test(x);
  }

  if (!v1parts.every(isValidPart) || !v2parts.every(isValidPart)) {
    return NaN;
  }

  if (zeroExtend) {
    while (v1parts.length < v2parts.length) v1parts.push('0');
    while (v2parts.length < v1parts.length) v2parts.push('0');
  }

  if (!lexicographical) {
    v1parts = v1parts.map(Number);
    v2parts = v2parts.map(Number);
  }

  for (let i = 0; i < v1parts.length; ++i) {
    if (v2parts.length === i) {
      return 1;
    }

    if (v1parts[i] > v2parts[i]) {
      return 1;
    }

    if (v1parts[i] < v2parts[i]) {
      return -1;
    }
  }

  if (v1parts.length !== v2parts.length) {
    return -1;
  }

  return 0;
}

export function isAppMarket() {
  return window.navigator.userAgent.includes('Tencent AppMarket');
}

const JSONP_CALLBACK = 'syzsjsonpcallback';
let jsonpId = 0;
export function getTk() {
  const skey = getCookie('skey') || getCookie('accesstoken');

  if (skey) {
    let hash = 5381;
    for (let i = 0, len = skey.length; i < len; ++i) {
      hash += (hash << 5) + skey.charAt(i).charCodeAt(0);
    }

    return hash & 0x7fffffff;
  }

  return '';
}

export function jsonp<T>(url: string) {
  const callbackName = `${JSONP_CALLBACK}${jsonpId}`;
  jsonpId += 1;
  let callbackData;
  (window)[callbackName] = (res) => {
    callbackData = res;
  };

  const urlObj = new URL(url);
  urlObj.searchParams.append('callback', callbackName);
  urlObj.searchParams.append('gjtk', String(getTk()));

  return new Promise<T>((resolve, reject) => {
    const script = document.createElement('script');
    const fetchUrl = urlObj.toString();
    script.charset = 'UTF-8';
    script.async = true;
    script.onerror = (e) => {
      reject(e);
      if (script.parentElement) {
        script.parentElement.removeChild(script);
      }
    };

    script.onload = () => {
      resolve(callbackData);
      if (script.parentElement) {
        script.parentElement.removeChild(script);
      }

      delete window[callbackName];
    };

    script.src = fetchUrl;
    document.body.appendChild(script);
  });
}
